import { ReactComponent as Icon } from "../images/long-arrow.svg";

const LongArrow  = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default LongArrow;